import { useEffect, useRef } from 'react';

const items = [
  { icon: 'ri-truck-line', label: 'Free White-Glove Delivery', sub: 'All orders over $1,500' },
  { icon: 'ri-tools-line', label: 'Expert Assembly', sub: 'Professional in-home setup' },
  { icon: 'ri-shield-line', label: '10-Year Warranty', sub: 'On all solid wood frames' },
  { icon: 'ri-draft-line', label: 'Free Design Consult', sub: 'In showroom or virtual' },
  { icon: 'ri-refresh-line', label: '60-Day Returns', sub: 'Hassle-free guarantee' },
];

export default function TrustStrip() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) ref.current?.classList.add('visible'); }, { threshold: 0.2 });
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  return (
    <section className="bg-cream-DEFAULT border-b border-cream-dark py-10">
      <div ref={ref} className="fade-in max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 divide-x divide-cream-dark">
          {items.map((item, i) => (
            <div key={item.label} className={`flex flex-col items-center text-center px-4 ${i === 0 ? '' : ''}`}>
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-gold text-2xl`} />
              </div>
              <span className="text-dark font-semibold text-sm">{item.label}</span>
              <span className="text-dark/40 text-xs mt-1">{item.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
